import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IApplicationState } from 'src/state';
import { accountOfferRequest } from 'src/state/offers/accountguard/actions';
import { IClaimOfferRequestState } from 'src/state/offers/accountguard/types';
import InfoSection from '../shared/InfoSection';

interface IAccountGuardPlansProps {
  setRef?: (el: HTMLDivElement | null) => void;
  accountGuard: IClaimOfferRequestState;
  accountOfferRequest: typeof accountOfferRequest;
}

const AccountGuardFeatures = (props: IAccountGuardPlansProps) => {
  const isClaimDisabled = props.accountGuard.claimStatus || props.accountGuard.sentSuccessfully;

  return (
    <div
      id="features"
      className="current-features"
      tabIndex={-1}
      ref={el => {
        if (props.setRef !== undefined) {
          props.setRef(el);
        }
      }}
    >
       <InfoSection
        category="AccountGuardV2"
        imagePath1="hub-redesign/AccountGuard/AcctGrd-Feature1-1920.jpg"
        title1="UnifiedThreatMonitoringTitle"
        description1="UnifiedThreatMonitoringDescription"
        cardButton1="FreeAssessment"
        cardLink1="https://aka.ms/Security-Program-for-Nonprofits"
        imagePath2="hub-redesign/AccountGuard/AcctGrd-Feature2-1920.jpg"
        title2="SecureHybridTitle"
        description2="SecureHybridDescription"
        cardButton2="TopBannerButton2"
        cardLink2="https://admin.cloud.microsoft/?source=applauncher#/catalog"
        imagePath3="hub-redesign/AccountGuard/AcctGrd-Feature3-1920.jpg"
        title3="SecurityToolsTitle"
        description3="SecurityToolsDescription"
        cardButton3="ClaimNowText"
        onClickAction3={() => props.accountOfferRequest()}
        ctaDisabled3={isClaimDisabled}
      />

    </div>
  );
};

const mapStateToProps = ({ offers }: IApplicationState) => ({
  accountGuard: offers.accountGuardOffer
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  accountOfferRequest: () => dispatch(accountOfferRequest())
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountGuardFeatures);
